import axios from 'axios';
import BaseApi from './base-api';

class CloseoutApi extends BaseApi {
  getCloseout(projectId) {
    return axios
      .get(`${this.baseUrl}/projects/${projectId}/closeout`)
      .then((response) => {
        return {
          ok: true,
          closeout: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateCloseout(projectId, values) {
    const params = {
      closeout: {
        warranty_date: values.warrantyDate,
        due_date: values.dueDate,
      },
    };
    return axios
      .put(`${this.baseUrl}/projects/${projectId}/closeout`, params)
      .then((response) => {
        return {
          ok: true,
          closeout: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  requestCloseout(projectId) {
    return axios
      .put(`${this.baseUrl}/projects/${projectId}/closeout/send_request`)
      .then((response) => {
        return {
          ok: true,
          closeout: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const closeoutApi = new CloseoutApi();



// WEBPACK FOOTER //
// ./src/services/api/closeout-api.js